import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { RotatingLines } from "react-loader-spinner";
import { useSearchWorkers } from "../../../context/SearchWorkersContext";

const SupportChildComponent = ({
  onUpdate,
  supportChildValue,
  isError,
  clearError,
}) => {
  const { isSelectionIdReady, getSelectionIdFromCookies } = useSearchWorkers();
  const [supportChild, setSupportChild] = useState(supportChildValue);
  const [selectionId, setSelectionId] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    if (isSelectionIdReady) {
      const selectionId = getSelectionIdFromCookies();
      console.log(
        "[SupportChildComponent] Retrieved selectionId:",
        selectionId
      );

      if (!selectionId) {
        console.warn("No selectionId found. Redirecting to /search-workers...");
        navigate("/account/fs-dashboard/search-workers");
      }
    }
  }, [isSelectionIdReady, getSelectionIdFromCookies, navigate]);

  useEffect(() => {
    setSupportChild(supportChildValue);
    console.log("Selected Support child value: ", supportChildValue);
  }, [supportChildValue]);

  const handleChange = (e) => {
    setSupportChild(e.target.value);
    onUpdate(e.target.value);
    clearError();
  };
  if (!selectionId) {
    <div style={{ textAlign: "left", marginLeft: "20px" }}>
      <RotatingLines
        visible={true}
        height="76"
        width="36"
        color="grey"
        strokeWidth="3"
        animationDuration="0.75"
        ariaLabel="rotating-lines-loading"
        wrapperStyle={{}}
        wrapperClass=""
      />
      <p>Loading, please wait...</p>
    </div>;
  }

  return (
    <div className="support-child-container">
      <h2>Is Child Support needed?</h2>
      <p>
        Only valid WWCC ( Working With Children Check )
        is needed for child support.
      </p>
      <div className="sc-radio-container">
        <input
          type="radio"
          id="yes"
          name="supportChild"
          value="yes"
          checked={supportChild === "yes"}
          onChange={handleChange}
        />
        <label htmlFor="yes">Yes</label>
      </div>
      <div className="sc-radio-container">
        <input
          type="radio"
          id="no"
          name="supportChild"
          value="no"
          checked={supportChild === "no"}
          onChange={handleChange}
        />
        <label htmlFor="no">No</label>
      </div>
      {isError && (
        <span className="sc-error-message">Please make a selection.</span>
      )}
    </div>
  );
};

export default SupportChildComponent;
